import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';

const SITE_LINKS = [
  { to: '/posts', label: 'Posts' },
  { to: '/cap', label: 'Cap' },
  { to: '/contact', label: 'Contact' },
];

const LEGAL_LINKS = [
  { to: '/pp', label: 'Privacy Policy' },
  { to: '/tos', label: 'Terms of Service' },
];

const Footer = () => {
  return (
    <footer className="ff-footer">
      <div className="ff-footer__inner ff-footer--minimal">
        <div className="ff-footer__bottom">
          <span className="ff-footer__copyright">FlightFormula © {new Date().getFullYear()}</span>
          <div className="ff-footer__right">
            <nav className="ff-footer__links" aria-label="Links">
              {SITE_LINKS.map((item) => (
                <Link key={item.to} to={item.to} className="ff-link-inline ff-footer__link">
                  {item.label}
                </Link>
              ))}
            </nav>
            <nav className="ff-footer__links" aria-label="Legal">
              {LEGAL_LINKS.map((item) => (
                <Link key={item.to} to={item.to} className="ff-link-inline ff-footer__link">
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="ff-footer__socials" aria-label="Social links">
              <a href="https://www.instagram.com/flightformula/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.tiktok.com/@flightformula" target="_blank" rel="noreferrer" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a href="https://www.youtube.com/@FlightFormula" target="_blank" rel="noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
